"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionRegistryWidget = void 0;
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var react_1 = __importStar(require("react"));
var WithComplexWidgetHoverManager_1 = require("../WithComplexWidgetHoverManager");
var AccordionContext_1 = require("./AccordionContext");
var AccordionSelection_1 = require("./AccordionSelection");
var inversify_react_1 = require("inversify-react");
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var ACCORDION_BASE_CLASS_NAME = "accordion-widget";
var AccordionWidgetComponent = (function (_super) {
    __extends(AccordionWidgetComponent, _super);
    function AccordionWidgetComponent() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleSetExpanded = function (expanded) {
            var _a = _this.props, widgetManager = _a.widgetManager, element = _a.element;
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", {
                action: EditorTypes_1.AccordionActionType.SetExpanded,
                path: widgetManager.getPath(element),
                expanded: expanded,
            }));
        };
        _this.handleSwapImageClick = function () {
            var _a = _this.props, widgetManager = _a.widgetManager, element = _a.element;
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", {
                action: EditorTypes_1.AccordionActionType.SwapImage,
                path: widgetManager.getPath(element),
            }));
        };
        _this.handleVisualAccordionImageClick = function (event) {
            if (_this.isVisualStyleAccordion && event.target === event.currentTarget) {
                event.preventDefault();
                _this.handleSelectorClick();
            }
        };
        return _this;
    }
    Object.defineProperty(AccordionWidgetComponent.prototype, "isSelected", {
        get: function () {
            return ([AccordionSelection_1.AccordionSelectionType.Full, AccordionSelection_1.AccordionSelectionType.Around].includes(this.props.selection) ||
                this.props.isUsingToolbar);
        },
        enumerable: false,
        configurable: true
    });
    AccordionWidgetComponent.prototype.handleSelectorClick = function () {
        var _a = this.props, widgetManager = _a.widgetManager, element = _a.element;
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", {
            action: EditorTypes_1.AccordionActionType.SelectAccordion,
            path: widgetManager.getPath(element),
        }));
    };
    Object.defineProperty(AccordionWidgetComponent.prototype, "isVisualStyleAccordion", {
        get: function () {
            var style = this.props.style;
            return style.cardStyle === "visual";
        },
        enumerable: false,
        configurable: true
    });
    AccordionWidgetComponent.prototype.render = function () {
        var _a;
        var _b = this.props, attributes = _b.attributes, children = _b.children, expanded = _b.expanded, backgroundImageUrl = _b.backgroundImageUrl, hoverManager = _b.hoverManager, style = _b.style;
        return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)("".concat(ACCORDION_BASE_CLASS_NAME), "project-block__block-element", (_a = {},
                _a["".concat(ACCORDION_BASE_CLASS_NAME, "--hide-selection")] = this.isSelected,
                _a)) }, attributes, hoverManager.handlers),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(ACCORDION_BASE_CLASS_NAME, "__content")) },
                react_1.default.createElement(AccordionContext_1.AccordionContext.Provider, { value: {
                        expanded: expanded,
                        setExpanded: this.handleSetExpanded,
                        isVisualStyleAccordion: this.isVisualStyleAccordion,
                        backgroundImageUrl: backgroundImageUrl,
                        handleSwapImageClick: this.handleSwapImageClick,
                        handleVisualAccordionImageClick: this.handleVisualAccordionImageClick,
                        showControls: this.isSelected || hoverManager.isHovered,
                        style: style,
                    } }, children))));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AccordionWidgetComponent.prototype, "isSelected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AccordionWidgetComponent.prototype, "isVisualStyleAccordion", null);
    AccordionWidgetComponent = __decorate([
        mobx_react_1.observer
    ], AccordionWidgetComponent);
    return AccordionWidgetComponent;
}(react_1.default.Component));
var AccordionWidget = (0, WithComplexWidgetHoverManager_1.withComplexWidgetHoverManager)(AccordionWidgetComponent);
var AccordionRegistryWidget = function (_a) {
    var attributes = _a.attributes, element = _a.element, children = _a.children, style = _a.style;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var selection = (0, useSelectionState_1.useSelectionState)(element);
    var accordionSelection = mapSelectionToAccordionSelection(selection.widgetSelectionState);
    var isUsingToolbar = false;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var usingVisualAccordion = true;
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var ensuringAccordionImageRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (style.cardStyle === "visual") {
            if (!element.data.backgroundImageUrl) {
                if (!ensuringAccordionImageRef.current) {
                    ensuringAccordionImageRef.current = true;
                    var path = widgetManager.getPath(element);
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", { action: EditorTypes_1.AccordionActionType.EnsureVisualAccordionImage, path: path }));
                }
            }
            else {
                ensuringAccordionImageRef.current = false;
            }
        }
    }, [element, element.data.backgroundImageUrl, style.cardStyle, widgetManager]);
    return (react_1.default.createElement(AccordionWidget, { widgetManager: widgetManager, element: element, attributes: attributes, selection: accordionSelection, isUsingToolbar: isUsingToolbar, blockStore: blockStore, brandStore: brandStore, telemetry: telemetry, expanded: element.data.expanded, backgroundImageUrl: element.data.backgroundImageUrl, usingVisualAccordion: usingVisualAccordion, stylePermissionStore: stylePermissionStore, style: style }, children));
};
exports.AccordionRegistryWidget = AccordionRegistryWidget;
var mapSelectionToAccordionSelection = function (widgetSelectionState) {
    return ({
        none: AccordionSelection_1.AccordionSelectionType.None,
        around: AccordionSelection_1.AccordionSelectionType.Around,
        circle: AccordionSelection_1.AccordionSelectionType.Full,
    }[widgetSelectionState] || AccordionSelection_1.AccordionSelectionType.None);
};
